const storeLocator = require('./storeLocator/index');

$(() => {
  storeLocator.init();
});
